import React, { useEffect, useState } from 'react'
import AdministrationForm from '../UI/AdministrationForm/AdministrationForm'
import apiService from '../../Services/apiServices'
import helper from '../../Services/helper'

const Project = (props) => {
    const [warehouses, setWarehouses] = useState()
    const [modal, setModal] = useState()

    const t = (key) => {
        return helper().translate(key);
    }

    const headers = [
        // { key: 'id', columnName: t('Id'), type: 'input', required: true },
        { key: 'name', columnName: t('NAME'), type: 'input', required: true },
        { key: 'warehouseId', name: "warehouseName", columnName: t('WAREHOUSE'), type: 'select', options: warehouses,  required: false },
        { key: 'contactPerson', columnName: t('MANAGER'), type: 'input', required: false },
        { key: 'address', columnName: t('ADDRESS'), type: 'input', required: false },
        { key: 'phone', columnName: t('PHONE'), type: 'input', required: false },
        { key: 'isDefault', columnName: t('DEFAULT'), type: 'switch', onlyTrue: true, options: [{value: 0, label: 'Jo'}, {value: 1, label: 'Po'}], required: false },
    ]

    const model = {
        id: 0,
        name: "",
        warehouseId: 0,
        contactPerson: "", 
        address: "",
        phone: "",
        isDefault: 0,
        createdAt: new Date(),
        status: 0
    }

    const getWarehouses = () => {
        apiService().get('warehouses')
            .then((response)=> {
                if(response.success) {
                    let records = response.data.map(record => ({ value: record.id, label: record.name }));
                    setWarehouses(records)
                }
            })
    }

    const performRefresh = () => {
        alert('reffff')
    }

    useEffect(() => {
        getWarehouses();
    }, [])

    useEffect(() => {
        setModal(props.modal)
    }, [props.modal]);

    return (
        <div>
            <AdministrationForm new={modal} headers={headers} table="projects" name="Projekti" model={model} formType="modal" />
        </div>
    )
}

export default Project
